<template>
  <el-collapse v-model="activeNames">
    <el-collapse-item title="基本信息" name="1">
      <info-item
        :title="['合同编号', '合同名称']"
        :data="[detail.htbh1, detail.htmc]"
      ></info-item>
      <info-item
        :title="['关联客户', '关联商机']"
        :data="[row.customerName, detail.glsj]"
      ></info-item>
      <info-item
        :title="['关联项目', '产品线']"
        :data="[detail.xmmc, detail.cpx]"
      ></info-item>
      <info-item
        :title="['收支类型', '合同类型']"
        :data="[detail.szlx, detail.htlx]"
      ></info-item>
      <info-item
        :title="['币种', '金额']"
        :data="[detail.bzn, detail.htjexx]"
      ></info-item>
      <info-item
        :title="['合作模式', '结算方式']"
        :data="[detail.hzms, detail.htjsfs]"
      ></info-item>
      <info-item
        :title="['结算比例', '开票方式']"
        :data="[detail.jsbl, detail.kpfs]"
      ></info-item>
      <info-item
        :title="['合同期限', '签订日期']"
        :data="[detail.ztzzlx, detail.htgdrq]"
      ></info-item>
      <info-item
        :title="['合同起始日', '合同结束日']"
        :data="[detail.htsxr, detail.htzzr]"
      ></info-item>
      <info-item
        :title="['我方签约主体', '公司所属板块']"
        :data="[detail.wfqyzt, detail.gsssbk]"
      ></info-item>
      <info-item
        :title="['费用承担部门', '最小预算单元']"
        :data="[detail.fycdbm, detail.zxysdy]"
      ></info-item>
      <info-item
        :title="['最小预算单元负责人', '签约形式']"
        :data="[detail.zxysdyfzr, detail.qyxs]"
      ></info-item>
      <info-item
        :title="['合同期限', '是否涉及场地租赁']"
        :data="[detail.ztzzlx, detail.sfsjcdsy]"
      ></info-item>
      <info-item
        :title="['备注', '是否使用模板']"
        :data="[detail.bz, detail.sfsymb]"
      ></info-item>
      <info-item
        :title="['模板类型', '合同模板']"
        :data="[detail.mblx, detail.htmb]"
      ></info-item>
      <info-item
        :title="['用印类型', '是否需要盖法人章']"
        :data="[detail.yylx, detail.sfxygfrz]"
      ></info-item>
      <info-item
        :title="['盖章说明', '用印份数']"
        :data="[detail.gzsm, detail.yyfs]"
      ></info-item>
      <info-item
        :title="['已收款金额（元）', '已开票金额（元）']"
        :data="[detail.refundAmount, detail.invoiceAmount]"
      ></info-item>
      <info-item
        :title="['未收款金额（元）', '业务员']"
        :data="[detail.waitRefundAmount, detail.salesmanName]"
      ></info-item>
      <info-item
        :title="['业务员所属部门',]"
        :data="[detail.teamName]"
      ></info-item>
    </el-collapse-item>
    <el-collapse-item title="系统信息" name="2">
      <info-item
        :title="['申请人', '申请日期']"
        :data="[detail.sqr, detail.sqrq]"
      ></info-item>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import InfoItem from "~component/base/detail-info-item.vue";

export default {
  props: {
    detail: Object,
    contractModule: Number,
    row: Object,
  },
  components: {
    InfoItem,
  },
  data() {
    return {
      activeNames: ["1", "2"],
    };
  },
};
</script>

<style lang="less">
@import "~@/styles/common.less";

.panel-item {
  padding: 0 10px;
  label {
    width: 150px;
    display: inline-block;
    color: @color--info;
  }
  &:last-child {
    .el-col {
      border: none;
    }
  }
}
</style>
